<template>
    <div class="px-4 pt-3" style="position: relative;">

        <div class="d-flex flex-column align-items-center align-items-md-start">
            <div class="mr-auto" v-if="project">
                <h1 class="mb-2">{{ project.name }}</h1>
                <h6 class="text-muted">
                    <strong>{{ project.name }}</strong> / {{ current_page.title }}</h6>
            </div>
            <div class="mr-auto" v-else-if="path">
                <h1 class="mb-2">{{ path.name }}</h1>
                <h6 class="text-muted">
                    <strong>Learning Paths</strong> / {{ path.name }}</h6>
            </div>
            <div id="app-heading-actions" class="w-100 ml-auto ml-md-0 mt-0 my-md-3"></div>
        </div>

        <teleport v-if="teleport_location" :to="teleport_location">
                    <div class="w-100 d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center">
                            <div v-if="project">
                                <div class="btn-group mr-3">
                                    <template v-for="(page, key) in pages">
                                        <button class="btn"
                                                :key="key"
                                                v-if="page?.enabled"
                                                :class="page?.active ? (page.active(page) ? 'btn-dark' : 'btn-light') : 'btn-light'"
                                                @click="page.action">
                                            {{ page.title }}
                                        </button>
                                    </template>

                                </div>
                            </div>
                            <div>
                                <div v-if="actions" class="btn-group">
                                    <button v-for="(action, key) in actions" :key="key"
                                            class="btn"
                                            :class="action.class ? action.class : 'btn-light'"
                                            @click.prevent.stop="$emit('action', key, action)">
                                        {{ action.title }}
                                    </button>
                                </div>
                            </div>
                            <a target="_blank" rel="noopener" v-if="path.meta?.guidelines" :href="uploads.url(path.meta?.guidelines?.url)">
                                <button class="btn btn-light">
                                    Standard Alignment Guidelines
                                </button>
                            </a>
                        </div>



                        <div class="d-none d-lg-block" v-if="teleport_location == '#app-nav-left'">
                            <a target="_blank" rel="noopener" class="sponsor-2" v-if="path.meta?.sponsor_logo" :href="path.meta?.sponsor_url">
                                <img :src="uploads.image(path.meta.sponsor_logo.preview_url, {w: 50, h: 50})" alt="">
                                <h2 v-if="path.meta?.sponsor_name">{{ path.meta.sponsor_name }}</h2>
                            </a>
                        </div>
                    </div>
        </teleport>


        <a target="_blank" rel="noopener" class="sponsor" v-if="path.meta?.sponsor_logo" :href="path.meta?.sponsor_url">
            <img :src="uploads.image(path.meta.sponsor_logo.preview_url, {w: 50, h: 50})" alt="">
            <h2 v-if="path.meta?.sponsor_name">{{ path.meta.sponsor_name }}</h2>
        </a>


        <!-- TODO: Should change it to Project Settings not Path Settings -->
        <template v-if="pages.settings.enabled && pages.settings.path">
            <project-settings-modal :project="project"
                                    :show="true"
                                    :show-clone="true"
                                    :show-delete="true"
                                    @cloned="projectCloned($event)"
                                    @close="closeSettings()"
                                    @deleted="projectDeleted()"/>
        </template>

    </div>
</template>

<script>
import ProjectSettingsModal from "@/Components/Project/ProjectSettingsModal";
import jQuery from "jquery";
import uploads from "../../mixins/uploads.js";
import RepeatInfo from "../Common/RepeatInfo.vue";
import Button from "../../Jetstream/Button.vue";

export default {
    name: "Heading",
    components: {Button, RepeatInfo, ProjectSettingsModal},
    props: ['project', 'path', 'page', 'actions', 'tenants'],
    emits: ['action'],
    mixins: [uploads],

    data(){
        return {

            teleport_location: null,

            pages: {
                details: {
                    enabled: true,
                    title: 'Project Details',
                    active: (page) => route().current() === 'project.details',
                    action: () => this.$inertia.visit(route('project.details', {project: this.project.id, ...this.global_url_params})),
                },
                path: {
                    enabled: true,
                    title: 'Learning Path',
                    active: (page) => route().current() === 'project.learning-path',
                    action: () => this.$inertia.visit(route('project.learning-path', {project: this.project.id, ...this.global_url_params})),
                },
                // preview: {
                //     enabled: true,
                //     title: 'Canvas Preview',
                //     active: (page) => route().current() === 'project.canvas.preview',
                //     action: () => this.$inertia.visit(route('project.canvas.preview', {project: this.project.id, ...this.global_url_params})),
                // },
                teams: {
                    enabled: true,
                    title: 'Teams',
                    active: (page) => route().current() === 'project.teams',
                    action: () => this.$inertia.visit(route('project.teams', {project: this.project.id, ...this.global_url_params})),
                },
                progress: {
                    enabled: true,
                    title: 'Progress',
                    active: (page) => route().current() === 'project.show',
                    action: () => this.$inertia.visit(route('project.show', {project: this.project.id, ...this.global_url_params})),
                },
                settings: {
                    enabled: this.has_edit_access,
                    path: null,
                    title: 'Settings',
                    action: () => this.openSettings(),
                }
            },
        }
    },

    computed: {
        current_page(){
            return this.pages[ this.page ];
        }
    },

    methods: {
        openSettings(){
            this.pages.settings.path = this.path;
        },

        closeSettings(){
            this.pages.settings.path = null;
        },

        projectDeleted(){
            this.$inertia.visit( route('project.dashboard', {...this.global_url_params}) );
            this.closeSettings();
        },

        projectCloned(project){
            this.$inert
ia.visit( this.route('project.learning-path', {project: project.id, ...this.global_url_params}) );
        },

        onScroll(){
            if( window.scrollY >= 100 && this.teleport_location !== '#app-nav-left' ){
                this.teleport_location = '#app-nav-left';
            }else if(window.scrollY < 100 && this.teleport_location !== '#app-heading-actions'){
                this.teleport_location = '#app-heading-actions';
            }
        }

    },


    mounted() {
        this.$nextTick(() => this.onScroll());
        jQuery(window).on('scroll', this.onScroll);
    },

    beforeUnmount() {
        jQuery(window).off('scroll', this.onScroll);
    }

}
</script>

<style lang="scss" scoped>
.force-relative{
    position: relative;
}

.sponsor{
    background: white;
    padding: 10px 20px;
    display: flex;
    gap: 10px;
    align-items: center;
    text-decoration: none;
    border-radius: .5rem;
    background: rgba(#dee2e5, 0.7);
    backdrop-filter: blur(5px);
    top: 10px;
    right: 10px;
    position: absolute;


    img{
        border-radius: 50%;
    }

    h2{
        margin-top: 5px;
        color: black;
        font-size: 16px;
    }

}

.sponsor-2{
    background: white;
    padding: 10px 20px;
    display: flex;
    gap: 10px;
    align-items: center;
    text-decoration: none;
    border-radius: .5rem;
    background: rgba(#dee2e5, 0.7);
    backdrop-filter: blur(5px);

    img{
        border-radius: 50%;
    }

    h2{
        margin-top: 5px;
        color: black;
        font-size: 16px;
    }

}

.wrapper{
    display: flex;
    width: 100% !important;
}
</style>
